(() => {
  const SECTION_ID = "main-collection-product-grid";

  const сел = {
    grid: "#product-grid",
    btn: "#CollectionLoadMore",
    countDesktop: "#ProductCountDesktop",
    countMobile: "#ProductCount",
  };

  function withSectionId(url) {
    const u = new URL(url, window.location.origin);
    // thêm section_id để Shopify trả về đúng HTML section
    u.searchParams.set("section_id", SECTION_ID);
    return u.toString();
  }

  async function fetchSectionHTML(url) {
    const res = await fetch(withSectionId(url), { credentials: "same-origin" });
    if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
    return await res.text();
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, "text/html");
  }

  async function handleLoadMore(btn) {
    const nextUrl = btn.dataset.nextUrl;
    if (!nextUrl) return;

    const grid = document.querySelector(сел.grid);
    if (!grid) return;

    const oldText = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Loading...";

    try {
      const html = await fetchSectionHTML(nextUrl);
      const doc = parseHTML(html);

      // 1) append products
      const newGrid = doc.querySelector(сел.grid);
      if (newGrid) {
        grid.insertAdjacentHTML("beforeend", newGrid.innerHTML);
      }

      // 2) update counts
      const newDesktop = doc.querySelector(сел.countDesktop);
      const curDesktop = document.querySelector(сел.countDesktop);
      if (newDesktop && curDesktop) curDesktop.innerHTML = newDesktop.innerHTML;

      const newMobile = doc.querySelector(сел.countMobile);
      const curMobile = document.querySelector(сел.countMobile);
      if (newMobile && curMobile) curMobile.innerHTML = newMobile.innerHTML;

      // 3) update next url or remove button if no more pages
      const newBtn = doc.querySelector(сел.btn);
      if (newBtn && newBtn.dataset.nextUrl) {
        btn.dataset.nextUrl = newBtn.dataset.nextUrl;
        btn.disabled = false;
        btn.textContent = oldText;
      } else {
        btn.remove();
      }
    } catch (e) {
      console.error(e);
      btn.disabled = false;
      btn.textContent = oldText;
    }
  }

  // ✅ Event delegation: luôn bắt được click dù facets có re-render section
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(сел.btn);
    if (!btn) return;
    e.preventDefault();
    handleLoadMore(btn);
  });
})();
